(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerType = this.getAttribute('data-sticky-type');
    this.headerIsAlwaysSticky = this.headerType === 'always';
    this.headerIsTransparentFixed = this.headerType === 'transparent-fixed';
    this.headerBounds = {};
    this.transparentPages = this.getAttribute('data-transparent-pages');
    this.shouldBeTransparent = this.checkIfTransparentPage();
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    if (this.headerIsTransparentFixed) {
      if (this.shouldBeTransparent) {
        this.header.classList.add('shopify-section-header-transparent-fixed');
        document.body.style.paddingTop = this.header.offsetHeight + 'px';
        const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (initialScrollTop <= 10) { this.header.classList.add('at-top'); this.header.classList.remove('scrolled-down'); }
        else { this.header.classList.remove('at-top'); this.header.classList.add('scrolled-down'); }
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'scrolled-down');
        this.headerIsAlwaysSticky = true;
      }
    }
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  checkIfTransparentPage() {
    if (!this.transparentPages) return document.body.classList.contains('template-index');
    const allowedPages = this.transparentPages.split(',').map(p => p.trim());
    for (let pageType of allowedPages) {
      switch(pageType) {
        case 'index': if (document.body.classList.contains('template-index')) return true; break;
        case 'collection': if (document.body.classList.contains('template-collection')) return true; break;
        case 'product': if (document.body.classList.contains('template-product')) return true; break;
        case 'page': if (document.body.classList.contains('template-page')) return true; break;
        case 'blog': if (document.body.classList.contains('template-blog')) return true; break;
        case 'article': if (document.body.classList.contains('template-article')) return true; break;
        case 'cart': if (document.body.classList.contains('template-cart')) return true; break;
        case 'search': if (document.body.classList.contains('template-search')) return true; break;
        case 'all': return true;
        default: if (document.body.classList.contains(`page-${pageType}`)) return true;
      }
    }
    return false;
  }
  setHeaderHeight() {
    const headerHeight = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    if (this.headerIsTransparentFixed && this.shouldBeTransparent) document.body.style.paddingTop = headerHeight + 'px';
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (this.headerIsTransparentFixed && this.shouldBeTransparent) {
      if (scrollTop > 10) { this.header.classList.add('scrolled-down'); this.header.classList.remove('at-top'); }
      else { this.header.classList.remove('scrolled-down'); this.header.classList.add('at-top'); }
      return;
    }
    if (this.headerIsAlwaysSticky) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
      else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() { this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); }
  reveal() { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset() { this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
